module.exports = __webpack_public_path__ + "img/Hills_case_study_3.6c16aaca.jpg";